import { useGoalById } from 'features/goals';
import React from 'react';
import { useParams } from 'react-router';
import { DateRange } from 'shared/types/date-range';

import { ProgressGrid } from '../progress-grid';

export type ProgressOverviewProps = {
  dateRange: DateRange;
  isAllRange?: boolean;
};

export const ProgressOverview: React.FC<ProgressOverviewProps> = ({
  dateRange,
  isAllRange,
}) => {
  const { id } = useParams();
  const goal = useGoalById(id);

  return !!goal ? (
    <ProgressGrid goal={goal} dateRange={dateRange} isAllRange={isAllRange} />
  ) : null;
};
